import axios from "axios";
import { client as openAPIClient } from '../api/services.gen';
import { 
    getUser as getUserOA,
    getEntries as getEntriesOA,
    getAwards as getAwardsOA,
    setEntryWatched as setEntryWatchedOA,
    setEntryToMyList as setEntryToMyListOA,
    getShareLink as getShareLinkOA,
    getShareLinks as getShareLinksOA,
    getGameCodes as getGameCodesOA,
    getGameCodesAvailability as getGameCodesAvailabilityOA,
    requestGameCode as requestGameCodeOA,
    getEntryNote as getEntryNoteOA,
    getEntryNotes as getEntryNotesOA,
    setEntryNote as setEntryNoteOA,
} from "../api/services.gen";
import { redirectToLogin, redirectToLogout } from "./User";

openAPIClient.setConfig({
    baseUrl: process.env.REACT_APP_SERVER_URL,
    credentials: "include",
});
openAPIClient.interceptors.response.use((response, request, options) => {
    const status = response.status;
    // user not logged in
    if (status === 401) {
        redirectToLogin();
        return response;
    }
    // user is logged in but not authorised
    else if(status === 403) {
        redirectToLogout();
        return response;
    }
    
    return response;
});

const API = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
    headers: {
        'Content-type': 'Application/json',
        'Accept' : 'Application/json'
    },
    withCredentials: true,
});

API.interceptors.request.use(
    // (config) => {
        // const { _auth }  = Cookies.get()
        // if(!_auth) {
        //     console.log("No authenticated")
        //     throw new axios.Cancel('No authenticated');
        // }
        // const auth = JSON.parse(_auth)
        // const token = auth['access_token']
        // config.headers["authorization"] = `Bearer ${token}`
        // return config;
    // },
    // (error) => {
    //     return Promise.reject(error);
    // }
);

API.interceptors.response.use(
    (next) => {
        return Promise.resolve(next);
    },
    (error) => {
        /*if (axios.isCancel(error)) {
            /* Cancelled when you have no access *
            window.location.href = loginUrl;
            return Promise.reject(error);
        }
        
        if(error.response.status === 401) {
            window.location.href = loginUrl;
            return;
        }*/
        return Promise.reject(error);
    }
);
export default API;

export async function getEntries(awardId: string|null, onlyMyList?: boolean|null) {
    // return (await API.get("/getEntries", { 'params': {
    //     awardId,
    //     onlyMyList: onlyMyList ? 1 : 0,
    // } })).data;
    return (await getEntriesOA({
        query: {
            awardId: awardId ?? undefined,
            onlyMyList: onlyMyList ?? undefined,
        },
    })).data;
}

export async function getEntryNotes() {
    // return await API.get("/getEntryNotes");

    return (await getEntryNotesOA());
}

export async function getEntryNote({
    awardId,
    entryId,
    categoryId = null,
}: {
    awardId: string,
    entryId: string,
    categoryId?: string|null,
}) {
    // return await API.get("/getEntryNote", {
    //     params: {
    //         awardId,
    //         entryId,
    //         categoryId,
    //     }
    // });

    return (await getEntryNoteOA({
        query: {
            awardId,
            entryId,
            ...(categoryId ? { categoryId } : {}),
        },
    }));
}

export async function setEntryNote({
    awardId,
    entryId,
    categoryId = null,
    note,
}: {
    awardId: string,
    entryId: string,
    categoryId?: string|null,
    note: string,
}) {
    // return await API.post("/setEntryNote", {
    //     awardId,
    //     entryId,
    //     ...(categoryId ? { categoryId } : {}),
    //     note,
    // });

    return (await setEntryNoteOA({
        body: {
            awardId,
            entryId,
            ...(categoryId ? { categoryId } : {}),
            note,
        },
    }));
}
export async function getUser() {
    // const response = await API.get('/getUser').then((res) => {
    //     return res.data;
    // }).catch(
    //     function (error) {
    //         return Promise.reject(error);
    //     }
    // )
    // return response;

    return (await getUserOA()).data;
}

export async function getAwards() {
    // const response = await API.get('/getAwards').then((res) => {
    //     return res.data;
    // }).catch(
    //     function (error) {
    //         return Promise.reject(error);
    //     }
    // )
    // return response;

    return (await getAwardsOA()).data;
}

export async function getTagsByAwardId(payload: object) {
    const response = await API.get('/getTags',{
        params: payload
    }).then((res) => {
        return res.data;
    }).catch(
        function (error) {
            return Promise.reject(error);
        }
    )
    return response;
}

export async function setEntryWatched(awardId: string, entryId: string, categoryId: string|null, isWatched: boolean) {
    // return await API.post("/setEntryWatched", {
    //     watched: isWatched,
    //     entryId: entryId,
    //     awardId: awardId,
    //     ...(categoryId ? { categoryId } : {})
    // });

    return (await setEntryWatchedOA({
        body: {
            watched: isWatched,
            entryId: entryId,
            awardId: awardId,
            ...(categoryId ? { categoryId } : {})
        },
    }));
}

export async function setEntryToMyList(awardId: string, entryId: string, categoryId: string|null, isInMyList: boolean) {
    // return await API.post("/setEntryToMyList", {
    //     entryId: entryId,
    //     awardId: awardId,
    //     ...(categoryId ? { categoryId } : {}),
    //     listed: isInMyList,
    // });

    return (await setEntryToMyListOA({
        body: {
            listed: isInMyList,
            entryId: entryId,
            awardId: awardId,
            ...(categoryId ? { categoryId } : {})
        },
    }));
}

export async function getPlayer(
    awardId: string,
    entryId: string,
    mediaItemId: string,
) {
    // return await API.get("/getShareLink", {
    //     params: {
    //         type: "player",
    //         awardId,
    //         entryId,
    //         mediaItemId,
    //     }
    // });

    return (await getShareLinkOA({
        query: {
            type: "player",
            awardId,
            entryId,
            mediaItemId,
        },
    }));
}

export async function getDownload(
    awardId: string,
    entryId: string,
    mediaItemId: string,
) {
    // return await API.get("/getShareLink", {
    //     params: {
    //         type: "download",
    //         awardId,
    //         entryId,
    //         mediaItemId,
    //     }
    // });

    return (await getShareLinkOA({
        query: {
            type: "download",
            awardId,
            entryId,
            mediaItemId,
        },
    }));
}


export async function getShareLinks(
    awardId: string,
    entryId: string,
    mediaItemIds: string[],
) {
    // return await API.get("/getShareLinks", {
    //     params: {
    //         type: "download",
    //         awardId,
    //         entryId,
    //         mediaItemIds: mediaItemIds.join(","),
    //     }
    // });
    return (await getShareLinksOA({
        query: {
            type: "download",
            awardId,
            entryId,
            mediaItemIds: mediaItemIds.join(","),
        },
    }));
}

export async function getGameCodes(
    awardId: string,
    entryId: string,
) {
    // const response = await API.get('/getgamecodes', {params: {awardId, entryId}}).then((res) => {
    //     return res.data;
    // }).catch(
    //     function (error) {
    //         return Promise.reject(error);
    //     }
    // )
    // return response;

    return (await getGameCodesOA({
        query: {
            awardId,
            entryId,
        },
    })).data;
}

export async function getGameCodesAvailability(
    awardId: string,
) {
    return (await getGameCodesAvailabilityOA({
        query: {
            awardId,
        },
    })).data;
}


export async function requestGameCode(
    awardId: string,
    entryId: string,
    platform: string,
) {
    // const response = await API.get('/requestgamecode', {params: {awardId, entryId, platform}}).then((res) => {
    //     return res.data;
    // }).catch(
    //     function (error) {
    //         return Promise.reject(error);
    //     }
    // )
    // return response;

    return (await requestGameCodeOA({
        query: {
            awardId,
            entryId,
            platform,
        },
    })).data;
}